import React, { memo, forwardRef } from "react";
const SvgDegree = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={9} y={11} fill="#DBDBDB" rx={2} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M25 8a3 3 0 11-6 0 3 3 0 016 0zm-3 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgDegree.displayName = "SvgDegree";
const MemoForwardRef = memo(SvgDegree);
export default MemoForwardRef;
